/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable func-names */
import * as yup from 'yup';
import type { AnyObject, Maybe } from 'yup/lib/types';
import { isObjectId, validateCpf, validatePhoneBr } from '../Utils/FnUtils';

export const requiredErrorMessage = 'Obrigatório';
export const invalidEmail = 'E-mail inválido';
export const invalidPhone = 'Número inválido';
export const invalidCpf = 'CPF inválido';
export const invalidYear = 'Ano inválido';
export const invalidPositiveNumber = 'O valor precisa ser positivo';
export const invalidObjectId = 'Id inválido';
export const notValidValue = 'O valor não é válido';
export const genericInvalidMessage = 'Campo inválido';

declare module 'yup' {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType,
  > extends yup.BaseSchema<TType, TContext, TOut> {
    telefone(errorMessage?: string): StringSchema<TType, TContext>;
    cpf(errorMessage?: string): StringSchema<TType, TContext>;
    ano(errorMessage?: string): StringSchema<TType, TContext>;
    objectId(errorMessage?: string): StringSchema<TType, TContext>;
  }
  interface NumberSchema<
    TType extends Maybe<number> = number | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType,
  > extends yup.BaseSchema<TType, TContext, TOut> {
    positiveOr0(errorMessage?: string): NumberSchema<TType, TContext>;
  }
}

yup.setLocale({
  mixed: {
    required: requiredErrorMessage,
    notType: notValidValue,
  },
  string: {
    email: invalidEmail,
  },
  number: {
    positive: invalidPositiveNumber,
  },
});

/* -------------------------------------------------------------------------- */
/*                              String functions                              */
/* -------------------------------------------------------------------------- */

yup.addMethod<yup.StringSchema>(
  yup.string,
  'telefone',
  function (errorMessage?: string) {
    return this.test(
      'telefone',
      errorMessage || invalidPhone,
      value => !value || !validatePhoneBr(value),
    );
  },
);

yup.addMethod<yup.StringSchema>(
  yup.string,
  'cpf',
  function (errorMessage?: string) {
    return this.test(
      'cpf',
      errorMessage || invalidCpf,
      value => !value || !validateCpf(value),
    );
  },
);

yup.addMethod<yup.StringSchema>(
  yup.string,
  'ano',
  function (errorMessage?: string) {
    return this.test(
      'ano',
      errorMessage || invalidYear,
      value => !value || value.length == 4,
    );
  },
);

yup.addMethod<yup.StringSchema>(
  yup.string,
  'objectId',
  function (errorMessage?: string) {
    return this.test(
      'objectId',
      errorMessage || invalidObjectId,
      value => !value || isObjectId(value),
    );
  },
);

/* -------------------------------------------------------------------------- */
/*                              Number functions                              */
/* -------------------------------------------------------------------------- */

yup.addMethod<yup.NumberSchema>(
  yup.number,
  'positiveOr0',
  function (errorMessage?: string) {
    return this.test(
      'positiveOr0',
      errorMessage || invalidPositiveNumber,
      value => !value || !!yup.number().moreThan(0).isValidSync(value),
    );
  },
);

export default yup;
